import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Button, createSelectField, DialogState, FileUpload, FileUploadArea, StandardDialog } from '@roc/ui';
import { TrackRecordPropertyForm } from './trackRecordPropertyForm';
import { TrackRecordProperties } from './trackRecordProperties';
import { PreScreenBorrowerTierNotification } from '@roc/feature-borrowers';
import ExcelIcon from './../../../../../assets/icon-microsoft-excel.png';
import { useEffect, useState } from 'react';
import { useDocumentLibraryStore } from '@roc/feature-document-library';
import { useRocInternalPortalStore } from 'apps/roc-internal-portal/src/app/hooks';
import { useBorrowerBaseballCardStore } from 'libs/feature-borrowers/src/borrowers/hooks/useBorrowerBaseballCardStore';

const useStyles = makeStyles((theme) => ({
  paddedGridItem: {
    paddingBottom: '5px',
    paddingTop: '15px',
  },
}));



export const TrackRecordFirstStep = observer(({ store, onDocUploadCallback = () => { } }) => {
  const { borrowerTier, trackRecordOtherFormStore } = store;
  const theme = useTheme();
  const [templateUploads, setTemplateUploads] = useState<FileUpload[]>([]);
  const { documentLibraryStore } = useDocumentLibraryStore();

  const [openModal, setOpenModal] = useState(false);

  const isInternalPortal = () => {
    if (store.globalStore.isInternalPortal) {
      return true;
    }
  }

  const { borrowerBaseballCardStore } = isInternalPortal() ? useRocInternalPortalStore() : useBorrowerBaseballCardStore();

  const classes = useStyles();

  useEffect(() => {
    store.isTrackRecordTemplateParsingAllowed();
  }, []);

  useEffect(() => {
    store.setTemplateUploads(templateUploads);
    store.parseTrackRecordTemplate(onDocUploadCallback);
    if (templateUploads.length > 0) {
      // Same agent call the loan-side upload makes; the store resolves the S3 path itself.
      store.invokeAgentFireAndForget({ trackRecordExcel: templateUploads[0]?.name });
    }
  }, [templateUploads]);

  const handleOpenModal = (value) => {
    store.trackRecordPropertyFormStore.onFieldChange('screenType', value)
    borrowerBaseballCardStore.propertyInformationDialogState = DialogState.ADD;
    store.setPropertyFormActive(true);
  };

  const handleCloseModal = async () => {
    await store.fetchTrackRecordProperties();
    await borrowerBaseballCardStore.setPropagateAddress(false);
    await store.setPropertyFormActive(false);
    store.trackRecordPropertyFormStore.reset();
  };

  const downloadTrackRecordTemplate = () => {
    try {
      documentLibraryStore.downloadTrackRecordTemplate();
    } catch (error) {
      console.log(error);
    }
  }

  const propertyButtons = () => {
    return (
      <Grid container justifyContent="flex-end" style={{ padding: '10px' }}>
        <Grid item>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => { handleOpenModal('entityName') }}
            testId={`addNewProperty`}
            style={{ marginLeft: '16px', backgroundColor: 'transparent' }}
          >
            Look up by entity
          </Button>

          <Button
            variant='outlined'
            color='primary'
            onClick={() => { handleOpenModal('propertyAddress') }}
            testId={`addNewProperty`}
            style={{ marginLeft: '16px', backgroundColor: 'transparent' }}
          >
            Look up by property
          </Button>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container direction='row' spacing={2} justifyContent='flex-end' style={{ paddingTop: '21px' }}>
      <Grid item container justifyContent="space-between" alignItems="center">
        <Typography variant={'h5'}>Track Record</Typography>
      </Grid>
      <Grid item container justifyContent="space-between" alignItems="center">
        <Typography>
          Please tell us about your previous real estate experience. If needed,{" "}
          <Typography
            component="span"
            style={{ cursor: 'pointer', color: theme.palette.primary.main, textDecoration: 'underline' }}
            onClick={() => downloadTrackRecordTemplate()}
          >
            Download Template
          </Typography>
        </Typography>
        {store.trackRecordTemplateParsingAllowed &&
          <Typography
            component="span"
            variant='subtitle2'
            style={{ cursor: 'pointer', color: theme.palette.primary.main, textDecoration: 'underline' }}
            onClick={() => store.setDigitalTrackRecord(!store.digitalTrackRecord)}
          >
            {store.digitalTrackRecord ? 'Upload using Track Record Template' : 'Continue with digital track record'}
          </Typography>
        }
        </Grid>

      <Grid container direction='row' spacing={2} justifyContent='center' style={{ padding: '0px 0px', maxWidth: '96%', margin: 'auto' }}>
        <Grid item xs={12}>
          {store.digitalTrackRecord ?
            <>

              <Grid item xs={12} style={{ paddingBottom: "12px" }}>
                <Typography>{store?.isTpoFlow ? 'To calculate the borrower\'s experience ranking, please add the properties of the deals that he has done in the past' : 'To calculate your experience ranking, please add the properties of the deals that you have done in the past'}</Typography>
              </Grid>
              {store.properties.length > 0 ? (
                <Grid item xs={12}>
                  <TrackRecordProperties store={store} propertyButtons={propertyButtons} borrowerBaseballCardStore={borrowerBaseballCardStore} />
                </Grid>
              ) : (
                propertyButtons()
              )}
              {(
                <StandardDialog open={store.isPropertyFormActive} handleClose={handleCloseModal}
                  maxWidth="xl"
                  fullWidth
                  PaperProps={{
                    style: {
                      maxHeight: '90vh',
                      overflowY: 'auto',
                    }
                  }}
                  dialogContent={
                    <Grid item xs={12}>
                      <TrackRecordPropertyForm store={store} handleClose={handleCloseModal} borrowerBaseballCardStore={borrowerBaseballCardStore} />
                    </Grid>
                  }
                >
                </StandardDialog>
              )}
            </>
            :
            <Grid item xs={12}>
              <Grid item xs={12}>
                <FileUploadArea
                  items={templateUploads}
                  setItems={(items) => setTemplateUploads(items)}
                  multiple={false}
                />
              </Grid>
            </Grid>
          }
        </Grid>
      </Grid>
    </Grid>
  );
});
